var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M8 11.4A3.4 3.4 0 1 1 11.4 8H13a5 5 0 1 0-5 5z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }